import { __assign } from "tslib";
import { assign, partial } from 'lodash-es';
import { connect } from 'react-redux';
import { deselectHandoffItem, flashHotspots, missClick, missedClick, screenTimer, screenTransitionCompleted, showNext, showPrevious, unsetScrollPos, } from '../actionCreators';
import Screen from '../components/Screen';
import controlScroll from '../hocs/controlScroll';
import { areCommentsVisible, getCurrentScreenProps, getIsSlideshowEnabled, getScreenStyles, isImageLoading, isInAnnotationMode, isInHandoffMode, isRecording, } from '../selectors';
import { getMissedClickPosition } from '../utils/tracking';
import { getEventMeta } from '../utils/userTest';
function mapStateToProps(state) {
    var props = getCurrentScreenProps(state);
    var screenStyles = getScreenStyles(state, true);
    return __assign(__assign({}, props), { scrollTop: screenStyles.scrollTop, smoothScroll: state.screen.smoothScroll, isLoading: isImageLoading(state, props.id), fixBounce: state.deviceDetection.isIOS &&
            screenStyles.isScrollableAreaScrollable &&
            !state.project.isFirstClick, areCommentsVisible: areCommentsVisible(state), isInHandoffMode: isInHandoffMode(state), isInAnnotationMode: isInAnnotationMode(state), isRecording: isRecording(state), getMissedClickPosition: partial(getMissedClickPosition, state), isTransitionComplete: state.screen.isTransitionComplete.current, getEventMeta: partial(getEventMeta, state), isSlideshowEnabled: getIsSlideshowEnabled(state) });
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var newProps = {
        onAnimationComplete: function () {
            dispatch(screenTransitionCompleted({ isCurrent: true }));
            dispatch(screenTimer(stateProps.timer));
        },
        // TODO we need a touch handler here for missed gestures
        onClick: function (id, clickArea, event, scrollPos) {
            if (stateProps.isInHandoffMode) {
                dispatch(deselectHandoffItem());
            }
            else if (stateProps.isSlideshowEnabled &&
                !stateProps.areCommentsVisible &&
                !stateProps.isInAnnotationMode &&
                !stateProps.isRecording) {
                var x = stateProps.getEventMeta(event).coords[0];
                if (x < stateProps.img.width / 2) {
                    dispatch(showPrevious());
                }
                else {
                    dispatch(showNext());
                }
            }
            else {
                event.stopPropagation();
                dispatch(
                // TODO this event is for Maze -- we should conditionally enable this
                missedClick(stateProps.getMissedClickPosition(id, clickArea, event), scrollPos));
                if (stateProps.isRecording) {
                    dispatch(missClick(stateProps.getEventMeta(event)));
                }
                dispatch(flashHotspots());
            }
        },
        onSetScrollEnd: function () {
            dispatch(unsetScrollPos());
        },
    };
    return assign({}, ownProps, stateProps, newProps);
}
var CurrentScreen = connect(mapStateToProps, null, mergeProps)(controlScroll(Screen));
export default CurrentScreen;
